$bog_dobro_app_settings $mol_page
	title @ \Settings
	body /
		<= Language_labeler $mol_labeler
			title @ \Interface language
			content /
				<= Language_select $mol_locale_select
					dictionary *
						ru \Russian
						en \English
						de \Deutsch
		<= Install_labeler $mol_labeler
			title @ \Install app
			content /
				<= Install_button $mol_button_major
					title @ \Add to Home Screen
					click? <=> install? null
	install_ios_instruction @ \To add to Home Screen on iPhone or iPad, tap Share and choose "Add to Home Screen".
	install_android_instruction @ \In Chrome on Android, open the menu (⋮) and choose "Install app".
	install_desktop_instruction @ \On desktop, use the install button in the address bar or the browser menu "Install app".
	install_unsupported_browser @ \Add to Home Screen is not supported in this browser.
	install_already_installed @ \The app is already installed or installation is not supported.
